<template>
    <div class="slide slide-section section-small">

        <div class="text-title">
            Now tell me about your savings and investments. Once we get this entered I would like to show you where we are so far.
        </div>

        <div class="back" @click="GoBack">
            <img src="/assets/img/icon-arrow-left-white.svg" />
        </div>

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-white.svg" />
        </div>

    </div>
</template>

<script>
export default {
    name: 'SectionThree',
    methods: {
        GoBack() {
            this.$router.go(-1);
        },
        next() {
            this.$router.push({ name: 'QuestionnaireAccounts' });
        }
    }
}
</script>
